function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import isoWeeksInYear from "dayjs/plugin/isoWeeksInYear";
import isLeapYear from "dayjs/plugin/isLeapYear";
dayjs.extend(isoWeek);
dayjs.extend(isoWeeksInYear);
dayjs.extend(isLeapYear);
var precisionRankRecord = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
export function defaultRenderLabel(type, data) {
  switch (type) {
    case "minute":
    case "second":
    case "hour":
      return ("0" + data.toString()).slice(-2);
    default:
      return data.toString();
  }
}
export function generateDatePickerColumns(selected, min, max, precision, renderLabel, filter) {
  var ret = [];
  var minYear = min.getFullYear();
  var minMonth = min.getMonth() + 1;
  var minDay = min.getDate();
  var minHour = min.getHours();
  var minMinute = min.getMinutes();
  var minSecond = min.getSeconds();
  var maxYear = max.getFullYear();
  var maxMonth = max.getMonth() + 1;
  var maxDay = max.getDate();
  var maxHour = max.getHours();
  var maxMinute = max.getMinutes();
  var maxSecond = max.getSeconds();
  var rank = precisionRankRecord[precision];
  var selectedYear = parseInt(selected[0]);
  var firstDayInSelectedMonth = dayjs(convertStringArrayToDate([selected[0], selected[1], "1"]));
  var selectedMonth = parseInt(selected[1]);
  var selectedDay = parseInt(selected[2]);
  var selectedHour = parseInt(selected[3]);
  var selectedMinute = parseInt(selected[4]);
  var isInMinYear = selectedYear === minYear;
  var isInMaxYear = selectedYear === maxYear;
  var isInMinMonth = isInMinYear && selectedMonth === minMonth;
  var isInMaxMonth = isInMaxYear && selectedMonth === maxMonth;
  var isInMinDay = isInMinMonth && selectedDay === minDay;
  var isInMaxDay = isInMaxMonth && selectedDay === maxDay;
  var isInMinHour = isInMinDay && selectedHour === minHour;
  var isInMaxHour = isInMaxDay && selectedHour === maxHour;
  var isInMinMinute = isInMinHour && selectedMinute === minMinute;
  var isInMaxMinute = isInMaxHour && selectedMinute === maxMinute;
  var generateColumn = function generateColumn(from, to, pre) {
    var column = [];
    for (var i = from; i <= to; i++) {
      column.push(i);
    }
    var prefix = selected.slice(0, precisionRankRecord[pre]);
    var currentFilter = filter === null || filter === void 0 ? void 0 : filter[pre];
    if (currentFilter && typeof currentFilter === "function") {
      column = column.filter(function (i) {
        return currentFilter(i, {
          get date() {
            var stringArray = [].concat(_toConsumableArray(prefix), [i.toString()]);
            return convertStringArrayToDate(stringArray);
          }
        });
      });
    }
    return column;
  };
  if (rank >= precisionRankRecord.year) {
    var lower = minYear;
    var upper = maxYear;
    var years = generateColumn(lower, upper, "year");
    ret.push(years.map(function (v) {
      return {
        label: renderLabel("year", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord.month) {
    var _lower = isInMinYear ? minMonth : 1;
    var _upper = isInMaxYear ? maxMonth : 12;
    var months = generateColumn(_lower, _upper, "month");
    ret.push(months.map(function (v) {
      return {
        label: renderLabel("month", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord.day) {
    var _lower2 = isInMinMonth ? minDay : 1;
    var _upper2 = isInMaxMonth ? maxDay : firstDayInSelectedMonth.daysInMonth();
    var days = generateColumn(_lower2, _upper2, "day");
    ret.push(days.map(function (v) {
      return {
        label: renderLabel("day", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord.hour) {
    var _lower3 = isInMinDay ? minHour : 0;
    var _upper3 = isInMaxDay ? maxHour : 23;
    var hours = generateColumn(_lower3, _upper3, "hour");
    ret.push(hours.map(function (v) {
      return {
        label: renderLabel("hour", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord.minute) {
    var _lower4 = isInMinHour ? minMinute : 0;
    var _upper4 = isInMaxHour ? maxMinute : 59;
    var minutes = generateColumn(_lower4, _upper4, "minute");
    ret.push(minutes.map(function (v) {
      return {
        label: renderLabel("minute", v),
        value: v.toString()
      };
    }));
  }
  if (rank >= precisionRankRecord.second) {
    var _lower5 = isInMinMinute ? minSecond : 0;
    var _upper5 = isInMaxMinute ? maxSecond : 59;
    var seconds = generateColumn(_lower5, _upper5, "second");
    ret.push(seconds.map(function (v) {
      return {
        label: renderLabel("second", v),
        value: v.toString()
      };
    }));
  }
  return ret;
}
export function convertDateToStringArray(date) {
  if (!date) return [];
  return [date.getFullYear().toString(), (date.getMonth() + 1).toString(), date.getDate().toString(), date.getHours().toString(), date.getMinutes().toString(), date.getSeconds().toString()];
}
export function convertStringArrayToDate(value) {
  var _a, _b, _c, _d, _e, _f;
  var yearString = (_a = value[0]) !== null && _a !== void 0 ? _a : "1900";
  var monthString = (_b = value[1]) !== null && _b !== void 0 ? _b : "1";
  var dateString = (_c = value[2]) !== null && _c !== void 0 ? _c : "1";
  var hourString = (_d = value[3]) !== null && _d !== void 0 ? _d : "0";
  var minuteString = (_e = value[4]) !== null && _e !== void 0 ? _e : "0";
  var secondString = (_f = value[5]) !== null && _f !== void 0 ? _f : "0";
  return new Date(parseInt(yearString), parseInt(monthString) - 1, parseInt(dateString), parseInt(hourString), parseInt(minuteString), parseInt(secondString));
}